<template>
  <div class="confirmation-page">

    <div class="top-section-centered">
      <img :src="successImg" alt="" aria-hidden="true" class="confirmation-image-centered" />
      <h3 class="centered-heading">Geschafft!</h3>
      <strong class="centered-strong">Ihre Anfrage ist erfolgreich bei uns eingegangen.</strong>
    </div>

    <div class="bottom-section">
      <h4 class="centered-heading">So geht es weiter:</h4>

      <ol class="steps-container-stacked">

        <li v-for="(card, index) in successCardsData"
            class="step-item-stacked"
            :key="index"
        >
          <div class="icon-wrapper">
            <div class="icon-circle">
              <img :src="card.imageSrc" :alt="card.imageAlt" aria-hidden="true" class="step-icon" />
            </div>
          </div>

          <div class="text-content">
            <h5>{{ card.headline }}</h5>
            <p v-html="card.text"></p>
          </div>
        </li>
      </ol>
    </div>
  </div>


</template>



<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '../../stores/workflow.js';
import {successCardsDataOnline, successCardsDataOnSite} from '@/data/successData.js';
import successImg from '@/assets/icons/fertig_blau.svg';
const workflowStore = useWorkflowStore();

const successCardsData = computed(() => {
  const isOnsite = workflowStore.workflowContext.formData.building?.appointment === 'onsite';

  // Wenn es 'online' ist, verwenden wir successCardsDataOnline, ansonsten successCardsDataOnSite.
  return isOnsite ? successCardsDataOnSite : successCardsDataOnline;
});

</script>

<style scoped>
#app-ves-clickstream .confirmation-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-size: 1.3em;
  line-height: 1.5;
}

/* Neue Klasse für mittigen oberen Bereich (Anforderungen 1, 2) */
#app-ves-clickstream .top-section-centered {
  display: flex;
  flex-direction: column; /* Stapelt Elemente vertikal */
  align-items: center; /* Zentriert horizontal */
  text-align: center;
  gap: 10px;
  margin-bottom: 30px;
}

#app-ves-clickstream .confirmation-image-centered {
  width: 150px; /* Kleinere Größe für mittiges Icon */
  height: 150px;
}

#app-ves-clickstream h3.centered-heading {
  font-size:2em;
  text-align: center; /* Stellt sicher, dass der Text zentriert ist */
  margin: 0;
}

#app-ves-clickstream h4.centered-heading {
  text-align: center;
  font-size: 1.2em;
}

#app-ves-clickstream .centered-strong {
  text-align: center;
  display: block; /* Wichtig für die Zentrierung des `strong`-Elements */
  font-size: 1.2em;
}

#app-ves-clickstream .section-divider {
  border: 0;
  height: 1px;
  background-color: #ccc;
  margin: 40px 0;
}

#app-ves-clickstream .bottom-section {
  margin-top: 40px;
}

#app-ves-clickstream .bottom-section h4 {
  /* Wird durch .centered-heading abgedeckt */
  margin-bottom: 30px;
  font-family: "VattenfallHall-Bold", "VattenfallHall-Regular",  Arial,Helvetica,sans-serif;
}

/* Neue Klasse für gestapelte Steps (Anforderungen 4, 5) */
#app-ves-clickstream .steps-container-stacked {
  list-style: none;
  padding: 0;
  margin: 0 auto; /* 4) Steps-Container mittig */
  max-width: 700px; /* Setzt eine maximale Breite, damit die Steps nicht zu breit werden */
}

/* Gestapeltes Step-Item (Anforderungen 5, 6, 7, 8) */
#app-ves-clickstream .step-item-stacked {
  display: flex;
  align-items: flex-start; /* Stellt sicher, dass das Icon oben links ausgerichtet ist */
  gap: 20px;
  padding: 20px 0;
  border-bottom: 1px solid #eee; /* Optische Trennung der Steps */
}

#app-ves-clickstream .step-item-stacked:last-child {
  border-bottom: none; /* Keine Trennlinie unter dem letzten Element */
}

/* 6) Runder weißer Hintergrund für das Icon */
#app-ves-clickstream .icon-wrapper {
  flex-shrink: 0; /* Verhindert, dass der Wrapper kleiner wird */
  padding-top: 5px; /* Kleiner Versatz, damit das Icon auf Höhe des Textes beginnt */
}

#app-ves-clickstream .icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%; /* Rund */
  background-color: #ffffff; /* Weißer Hintergrund */
  display: flex;
  align-items: center;
  justify-content: center;
}

#app-ves-clickstream .step-icon {
  width: 50px; /* Kleinere Icons im Kreis */
  height: 50px;
}

#app-ves-clickstream .text-content {
  flex-grow: 1; /* Nimmt den restlichen Platz ein */
  text-align: left; /* Text linksbündig */
}

/* 7) Headline als H5 */
#app-ves-clickstream .text-content h5 {
  font-family: "VattenfallHall-Bold", "VattenfallHall-Regular", Arial,Helvetica,sans-serif;
  font-size: 1.1em;
  margin-top: 0;
  margin-bottom: 5px;
  font-weight: bold;
}

/* 8) Text */
#app-ves-clickstream .text-content p {
  margin: 0;
  font-size: 0.9em;
  color: black;
}

/* Debug-Daten-Sektion unverändert am Ende */
#app-ves-clickstream .debug-data-section {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #ccc;
}

#app-ves-clickstream .debug-data-section .left-column {
  flex: 1;
  min-width: 200px;
}

#app-ves-clickstream .debug-data-section .right-column {
  flex: 1;
  min-width: 300px;
}

#app-ves-clickstream pre {
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;
  font-size: 0.8em;
}

/* Responsive Anpassungen für kleine Bildschirme */
@media (max-width: 768px) {
  /* ... (Bestehende 768px Regeln) ... */
  #app-ves-clickstream .debug-data-section {
    flex-direction: column;
  }
}

/* Neuer Media Query für die Step-Anordnung (max-width: 767px) */
@media (max-width: 767px) {
  /* ❗ Steps-Icon oberhalb der Überschrift */
  #app-ves-clickstream .step-item-stacked {
    /* Ändert die Hauptachse von "horizontal" (default: row) auf "vertikal" */
    flex-direction: column;
    align-items: center; /* Zentriert Icon und Text horizontal */
    text-align: center;
    gap: 10px; /* Reduziert den Abstand zwischen Icon und Text im vertikalen Stapel */
    padding: 20px; /* Erhöht das Padding, da es mehr Platz einnimmt */
  }

  /* Verschiebt das Icon an den Anfang des vertikalen Stapels */
  #app-ves-clickstream .icon-wrapper {
    order: -1; /* Stellt sicher, dass das Icon ganz oben steht */
    padding-top: 0; /* Entfernt den vertikalen Versatz */
    margin-bottom: 10px; /* Fügt Abstand nach unten hinzu */
  }

  /* Richtet den Textblock mittig aus */
  #app-ves-clickstream .text-content {
    text-align: center;
  }

  /* Stellt sicher, dass die Überschrift und der Text zentriert sind */
  #app-ves-clickstream .text-content h5,
  #app-ves-clickstream .text-content p {
    text-align: center;
  }

  /* Entfernt die maximale Breite für bessere Nutzung des mobilen Bildschirms */
  #app-ves-clickstream .steps-container-stacked {
    max-width: 100%;
  }
}
</style>